function InstagramIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_2253)">
        <path
          d="M18.768 16C18.768 17.5532 17.5138 18.8125 15.967 18.8125C14.4201 18.8125 13.166 17.5532 13.166 16C13.166 14.4468 14.4201 13.1875 15.967 13.1875C17.5138 13.1875 18.768 14.4468 18.768 16Z"
          fill="white"
        />
        <path
          d="M20.6976 7.5H11.2366C9.17719 7.5 7.50195 9.18213 7.50195 11.25V20.75C7.50195 22.8179 9.17719 24.5 11.2366 24.5H20.6976C22.757 24.5 24.4323 22.8179 24.4323 20.75V11.25C24.4323 9.18213 22.757 7.5 20.6976 7.5ZM15.9671 20.6875C13.393 20.6875 11.2988 18.5847 11.2988 16C11.2988 13.4153 13.393 11.3125 15.9671 11.3125C18.5412 11.3125 20.6354 13.4153 20.6354 16C20.6354 18.5847 18.5412 20.6875 15.9671 20.6875ZM21.3201 11.5625C20.8044 11.5625 20.3864 11.1428 20.3864 10.625C20.3864 10.1072 20.8044 9.6875 21.3201 9.6875C21.8358 9.6875 22.2537 10.1072 22.2537 10.625C22.2537 11.1428 21.8358 11.5625 21.3201 11.5625Z"
          fill="white"
        />
        <path
          d="M23.4986 0H8.43563C3.80236 0 0.0327148 3.78516 0.0327148 8.4375V23.5625C0.0327148 28.2148 3.80236 32 8.43563 32H23.4986C28.1319 32 31.9016 28.2148 31.9016 23.5625V8.4375C31.9016 3.78516 28.1319 0 23.4986 0ZM26.2996 20.75C26.2996 23.8516 23.7865 26.375 20.6977 26.375H11.2366C8.14776 26.375 5.63466 23.8516 5.63466 20.75V11.25C5.63466 8.14844 8.14776 5.625 11.2366 5.625H20.6977C23.7865 5.625 26.2996 8.14844 26.2996 11.25V20.75Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_2253">
          <rect
            width="31.8688"
            height="32"
            fill="white"
            transform="translate(0.0327148)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default InstagramIcon;
